<template lang="html">
  <div class="">
    <p>Vælg det ønskede afhentningssted herunder, eller indtast et andet postnr.</p>
    <div class="input-group mb-3">
      <input type="search" v-model="zipCode" @keyup="inputChange" maxlength="4" class="form-control" placeholder="Søg på postnummer">
      <div class="input-group-append">
        <a tabindex="0" type="submit" class="input-group-text pt-0 pr-2 pl-2 pb-0">
          <svg class="bi" width="23" height="23" fill="currentColor">
            <use href="../static/bi-sprite.svg#search"></use>
          </svg>
        </a>
      </div>
    </div>

	<div v-if="error" class="alert alert-warning" role="alert">Der blev ikke fundet nogen pakkeshops ud fra det angivne postnummer.</div>
	<div v-else>
      <ul v-if="!loading" class="list-group">
          <li v-for="shop in shops" class="list-group-item shop" :class="{ 'shop--active': selected !== null && shop.number === selected.number }">
              <a @click="selectedShop(shop)" class=" shop__link">
                  <span class="d-block">
                    <strong>{{shop.companyName}}</strong><br />
                    <span>{{shop.streetname}}</span><br />
                    <span>{{shop.zipCode}} {{shop.cityName}}</span>
                  </span>
                  <span class="shop__hours">
                      <template v-for="day in shop.openingHours">
                          <span>{{days[day.day]}} {{day.openAt.from}}-{{day.openAt.to}}</span><br>
                    </template>
                  </span>
              </a>
          </li>
      </ul>
      <div v-else class="text-center mt-5 mb-5">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
	</div>
  </div>
</template>

<script>
import Vue from "vue";
import { axiosApi as axios } from "./store/axios";

export default Vue.extend({
	name: "GlsApp",
	components: {},
	props: [],
	data() {
		return {
			zipCode: window.gls?.zip,
			street: window.gls?.address,
			shops: [],
			days: ["Man", "Tir", "Ons", "Tor", "Fre", "Lør", "Søn"],
			selected: null,
			loading: true,
			error: false,
			button: null
		};
	},
	created() {},
	mounted() {
		let self = this;
		
		this.button = document.querySelector("#glsp-submit");
		this.init();

		var $deliveryTypeFields = document.querySelectorAll('[name="deliverytype"]');
		$deliveryTypeFields.forEach(($deliveryTypeField) => {
			$deliveryTypeField.addEventListener("change", function(e) {
				updateFormError(false);
				if(e.target.getAttribute('data-glsApp') === "true") {
					window.gls.load = true;
					self.init();
				}
        	});
		});
	},
	methods: {
		init() {
			let id = window.gls?.id;
			
			if (id !== null && id !== undefined && id !== "") {
				axios
					.get("servicepointapi/gls", { params: { actionid: "one", id: id } })
					.then((result) => {
						this.selectedShop(result.data || result);
						this.search(false);
					})
					.catch((error) => {
						console.warn(error);
						this.error = true;
						updateFormError(true);
					});
			} else if(window.gls?.load) {
				this.search(true);
			}
		},
		inputChange(event) {
			let value = event.target.value;
			this.shops = [];
			if (String(value).length === 4) {
				this.search(false);
			}
		},
		search(initial = false) {
			this.loading = true;
			this.error = false;
			updateFormError(false);
			axios
				.get("/servicepointapi/gls", {
					params: {
						actionid: "nearest",
						zipCode: this.zipCode,
						street: this.street,
					},
				})
				.then((result) => {
					this.shops = result.data || result;
					if (initial && this.shops.length > 0) {
						this.selectedShop(this.shops[0]);
					}
					this.loading = false;
				})
				.catch((error) => {
					console.warn(error);
					this.error = true;
					if(initial) {						
						updateFormError(true);
					}					
				});
		},
		selectedShop(shop) {
			this.selected = shop;
			this.street = '';
			this.button.disabled = false;
			this.button.classList.remove("disabled");
			updateSelectedShopInDom(shop);
		},
	},
	computed: {},
});

function updateFormError (on = false){
	document.getElementById("glsp-error").classList.toggle('d-none', !on);
	document.getElementById("glsp-no-error").classList.toggle('d-none', on);
	document.querySelector('.js-delivery').classList.toggle('js-invalid', on);
}

function updateSelectedShopInDom (shop){
	if(shop !== undefined && shop !== null){
		document.getElementById("glsp-companyName").innerHTML = shop.companyName;
		document.getElementById("glsp-streetname").innerHTML = shop.streetname;
		document.getElementById("glsp-streetname2").innerHTML = shop.streetname2;
		document.getElementById("glsp-zipCode").innerHTML = shop.zipCode;
		document.getElementById("glsp-cityName").innerHTML = shop.cityName;
		document.getElementById("glsp-input-number").value = shop.number;
		document.getElementById("glsp-input-companyName").value = shop.companyName;
		document.getElementById("glsp-input-streetname").value = shop.streetname;
		document.getElementById("glsp-input-streetname2").value = shop.streetname2;
		document.getElementById("glsp-input-zipCode").value = shop.zipCode;
		document.getElementById("glsp-input-cityName").value = shop.cityName;
		document.getElementById("glsp-input-country").value = shop.countryCodeISO3166A2;
	}
};


</script>